import * as React from 'react';
import { green, pink } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import FolderIcon from '@mui/icons-material/Folder';
import PageviewIcon from '@mui/icons-material/Pageview';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { Grid, Card, Paper } from '@mui/material';

export default function AssetButtons() {
  return (
     
    <Grid container px={2} mt={1}  mb={2} rowSpacing={2} columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
      <Grid item xs={6} sm={3}>
      <Card sx={{borderRadius: '4px', paddingY: '5px'}}>
        <Box component={RouterLink}  to='/receive' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src='https://res.cloudinary.com/dqi4rtyvh/image/upload/v1738590761/deposit_bvwyrg.png' sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Deposit</Typography>   
        </Box>
        </Card>
      </Grid>

      <Grid item xs={6} sm={3}>
      <Card sx={{borderRadius: '4px', paddingY: '5px'}}>
        <Box component={RouterLink}  to='/send-coin' sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', borderRadius: '50%',  textDecoration: 'none', color: 'inherit' }}>
          <Avatar src='https://res.cloudinary.com/dqi4rtyvh/image/upload/v1738590761/withdraw_eqdznq.png' sx={{ padding: '5px', width: 40, height: 40}}>
            {/* <ArrowOutwardIcon /> */}
          </Avatar>  
          <Typography sx={{textAlign: 'center', fontSize: '12px'}}>Withdraw</Typography>   
        </Box>
        </Card>
      </Grid>

    </Grid>
  );
}